webpackJsonp([240578454594245],{

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-bottom: ', ';\n'], ['\n  padding-bottom: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-top: 1rem;\n\n  dt, dd {\n    display: inline-block;\n  }\n\n  dt: {\n  }\n\n  dt:after {\n    content: \': \';\n    margin-right: ', ';\n  }\n'], ['\n  margin-top: 1rem;\n\n  dt, dd {\n    display: inline-block;\n  }\n\n  dt: {\n  }\n\n  dt:after {\n    content: \': \';\n    margin-right: ', ';\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _H = __webpack_require__(30);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _ResumeContainer = __webpack_require__(26);
	
	var _ResumeContainer2 = _interopRequireDefault(_ResumeContainer);
	
	var _reactIntl = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Technologies = __webpack_require__(63);
	
	var _Technologies2 = _interopRequireDefault(_Technologies);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _A = __webpack_require__(35);
	
	var _A2 = _interopRequireDefault(_A);
	
	var _ramda = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Header = _styledComponents2.default.header(_templateObject, function (_ref) {
	  var theme = _ref.theme;
	  return theme.scale(1);
	});
	
	var getBreadCrumb = function getBreadCrumb(langKey, job) {
	  return [{
	    link: '/' + langKey + '/resume/jobs-and-clients/',
	    label: 'resume.jobsAndClients'
	  }, {
	    link: '/' + langKey + '/resume/jobs-and-clients' + job.slug,
	    label: job.name
	  }];
	};
	
	var Dl = _styledComponents2.default.dl(_templateObject2, function (_ref2) {
	  var theme = _ref2.theme;
	  return theme.scale(-2);
	});
	
	var getLink = function getLink(project) {
	  return project.link ? _react2.default.createElement(
	    Dl,
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'resume.project.link', tagName: 'dt' }),
	    _react2.default.createElement(
	      'dd',
	      null,
	      _react2.default.createElement(
	        _A2.default,
	        { href: project.link, target: '_blank' },
	        project.link
	      )
	    )
	  ) : null;
	};
	
	var getNYears = function getNYears(years) {
	  return (0, _ramda.head)(years) - (0, _ramda.last)(years) + 1;
	};
	
	var getYears = function getYears(years) {
	  var firstYear = (0, _ramda.head)(years);
	  var lastYear = (0, _ramda.last)(years);
	
	  var txt = firstYear === lastYear ? firstYear : firstYear + '/' + lastYear;
	
	  return [_react2.default.createElement(
	    Dl,
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, {
	      id: 'resume.project.years',
	      tagName: 'dt',
	      values: { nYears: getNYears(years) }
	    }),
	    _react2.default.createElement(
	      'dd',
	      null,
	      txt
	    )
	  )];
	};
	
	var getTechnologies = function getTechnologies(project) {
	  return project.technologies ? _react2.default.createElement(_Technologies2.default, { technologies: project.technologies }) : null;
	};
	
	var ProjectPage = function ProjectPage(props) {
	  var _props$pathContext = props.pathContext,
	      job = _props$pathContext.job,
	      project = _props$pathContext.project;
	  var menu = props.data.site.siteMetadata.resume.menu;
	
	  var description = project.description;
	
	  return _react2.default.createElement(
	    _ResumeContainer2.default,
	    {
	      menu: menu,
	      selectedPage: '/resume/jobs-and-clients/',
	      breadCrumb: getBreadCrumb(props.intl.locale, job)
	    },
	    _react2.default.createElement(
	      _reactIntl.FormattedMessage,
	      { id: 'resume' },
	      function (resume) {
	        return _react2.default.createElement(_reactHelmet2.default, {
	          title: resume + ' - ' + job.name + ' - ' + project.name,
	          meta: [{ name: 'description', content: description }]
	        });
	      }
	    ),
	    _react2.default.createElement(
	      Header,
	      null,
	      _react2.default.createElement(
	        _H2.default,
	        null,
	        project.name
	      )
	    ),
	    getLink(project),
	    getYears(project.years),
	    getTechnologies(project)
	  );
	};
	
	ProjectPage.propTypes = {
	  intl: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.shape({
	    project: _propTypes2.default.shape({
	      name: _propTypes2.default.string.isRequired,
	      slug: _propTypes2.default.string.isRequired,
	      technologies: _propTypes2.default.array.isRequired,
	      description: _propTypes2.default.string,
	      years: _propTypes2.default.array
	    }).isRequired,
	    job: _propTypes2.default.shape({
	      name: _propTypes2.default.string.isRequired,
	      slug: _propTypes2.default.string.isRequired
	    }).isRequired
	  }).isRequired,
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(ProjectPage);
	module.exports = exports['default'];

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProjectPage = __webpack_require__(453);
	
	var _ProjectPage2 = _interopRequireDefault(_ProjectPage);
	
	var _graphql = __webpack_require__(13);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectRoute = function ProjectRoute(props) {
	  return _react2.default.createElement(_ProjectPage2.default, props);
	};
	
	exports.default = ProjectRoute;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-resume-project-js-55f9e68e5629a330b365.js